<template>
  <div class="modal fade show d-block" tabindex="-1">
    <div class="modal-dialog modal-fullscreen-md-down modal-dialog-centered">
      <div class="modal-content border-ruderclub-dark-green">
        <div class="modal-header bg-ruderclub-dark-green">
          <h5 class="modal-title">
            <span class="d-flex">
              <span
                class="material-symbols-outlined d-flex align-self-center me-2"
                >settings</span
              >
              <span>Trainingsmodus</span>
            </span>
          </h5>
        </div>
        <div class="modal-body">
          <div
            class="mt-2 mb-4 alert alert-info"
            style="border-width: 3px !important"
          >
            Für das exakte vorhalten der Messdaten empfehle ich das Training
            <b>ohne</b>
            Bluetooth-Verbindung. So können die Daten nach dem Training vom
            Display des Trainingsgerätes abgelesen werden.
          </div>

          <div class="row">
            <div class="col-12 col-md-6">
              <div
                class="card border-ruderclub-orange trainingsmodus-card"
                style="border-width: 3px !important"
                @click="$emit('setzeTrainingsmodus', false)"
              >
                <div class="card-body">
                  <strong>Ohne Bluetooth-Verbindung trainieren</strong><br />
                  <small>Spiele sofort das Video ab.</small>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 mt-2 mt-md-0">
              <div
                class="card border-ruderclub-orange trainingsmodus-card"
                @click="$emit('setzeTrainingsmodus', true)"
              >
                <div class="card-body">
                  <strong>Mit Bluetooth-Verbindung trainieren</strong><br />
                  <small>Verbinde mein Gerät.</small>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-4 alert alert-warning">
            Das <b>Koppeln von Geräten via Bluetooth</b> funktioniert aktuell
            grundsätzlich nur unter <b>Google-Chrome</b> und nur mit den mir
            bisher bekannten Geräten und Geräteherstellern. Es kann sein, dass
            es zufällig auch mit anderen Herstellern und/oder Gerätemodellen
            funktioniert; in dem Fall würde ich mich sehr über eine Nachricht
            freuen.
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-between">
          <button
            class="btn btn-outline-secondary"
            @click="$emit('navigateTo', 'TrainingVideoDashboardView')"
          >
            Abbrechen
          </button>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.trainingsmodus-card {
  cursor: pointer;
}

.trainingsmodus-card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  border-color: var(--ruderclub-dark-green);
  background-color: var(--ruderclub-orange);
}
</style>
